import React, { memo } from 'react'
import { Link } from '@mui/material'
import { NAVIGATION_BLANK_PARAMS } from '../../../util/navigation.helpers'

const OutsideLink = ({
  label,
  isEmail,
  to,
  size,
  color,
  onClick,
  ...restProps
}) => {
  return (
    <Link
      size={size}
      color={color}
      href={isEmail ? `mailto:${to}` : to}
      onClick={onClick}
      {...NAVIGATION_BLANK_PARAMS}
      {...restProps}
    >
      {label}
    </Link>
  )
}

export default memo(OutsideLink)
